'use strict'

angular.module('rmBroadcast', [])

require('./controller/index.js')
require('./resources/index.js')
require('./routes.js')
